import { render, staticRenderFns } from "./UserAuthorizationsForm.vue?vue&type=template&id=22e1966e&scoped=true"
import script from "./UserAuthorizationsForm.vue?vue&type=script&lang=js"
export * from "./UserAuthorizationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1966e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e1966e')) {
      api.createRecord('22e1966e', component.options)
    } else {
      api.reload('22e1966e', component.options)
    }
    module.hot.accept("./UserAuthorizationsForm.vue?vue&type=template&id=22e1966e&scoped=true", function () {
      api.rerender('22e1966e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/user/partials/UserAuthorizationsForm.vue"
export default component.exports